// extracted by mini-css-extract-plugin
export var content = "floatMenuDesktop-module--content--6a463";
export var cta = "floatMenuDesktop-module--cta--6558c";
export var menu = "floatMenuDesktop-module--menu--0a664";
export var menuIcon = "floatMenuDesktop-module--menuIcon--4dc38";
export var searchForm = "floatMenuDesktop-module--searchForm--eadf9";
export var searchOnTablet = "floatMenuDesktop-module--searchOnTablet--6234a";
export var underlined = "floatMenuDesktop-module--underlined--5d8cf";
export var wrapper = "floatMenuDesktop-module--wrapper--206c0";
export var wrapperBg = "floatMenuDesktop-module--wrapperBg--695d0";